import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/client/legal/PrivacyPolicyClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/common/PageLoader.tsx");
